// extracted by mini-css-extract-plugin
export var root = "Search-module--root--tlhrW";
export var input = "Search-module--input--MXpuL";
export var button = "Search-module--button--dpGNU";
export var suggestions = "Search-module--suggestions--1JAl-";